import styled from 'styled-components';

export const Wrapper = styled.div`
  position: relative;
  padding: 1px 10px;
  .border {
    width: 6px;
    height: 40px;
    position: absolute;
    border-top-right-radius: 6px;
    border-bottom-right-radius: 6px;
    background: var(--sidebar-item-active);
    left: 0;
  }
`;

export const Container = styled.div`
  padding: 0 var(--sidebar-padding-x);
  display: flex;
  align-items: center;
  justify-content: space-between;
  cursor: pointer;
  width: 100%;
  height: 45px;
  background: ${({ active, hovered }) =>
    active || hovered ? 'var(--sidebar-item-active-background)' : ''};
`;

Container.Left = styled.div`
  display: flex;
`;

export const Title = styled.span`
  font-family: 'Inter';
  font-size: 16px;
  font-weight: 500;
  /* line-height: 16px; */
  color: ${({ active, hovered }) =>
    active || hovered
      ? 'var(--sidebar-item-active)'
      : 'var(--sidebar-item-inactive)'};
  opacity: ${({ collapsed }) => (collapsed ? '0' : '1')};
  display: inline-block;
  transition: 0.1s;
`;

export const IconContainer = styled.div`
  color: ${({ active, hovered }) =>
    active || hovered
      ? 'var(--sidebar-item-active)'
      : 'var(--sidebar-item-inactive)'};
  display: flex;
  align-items: center;
  min-width: 20px;
  margin-right: 8px;
  svg {
    path {
      stroke: ${({ active, hovered }) =>
        active || hovered
          ? 'var(--sidebar-item-active)'
          : 'var(--sidebar-item-inactive)'};
    }
  }
`;
